"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[3090],{

/***/ 9569:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/.pnpm/@hotwired+stimulus@3.2.2/node_modules/@hotwired/stimulus/dist/stimulus.js
var stimulus = __webpack_require__(7809);
// EXTERNAL MODULE: ./_components/core/shopify/format-money.js
var format_money = __webpack_require__(8306);
;// ./node_modules/.pnpm/@thebeyondgroup+shopify-rich-text-renderer@2.1.1/node_modules/@thebeyondgroup/shopify-rich-text-renderer/src/index.js
/* Shopify Metafield & Metaobject Rich Text Editor Schema to HTML Converter */

/**
 * Converts Shopify Richtext Schema to HTML.
 *
 * @param {Object|string} schema - The schema object or JSON string to convert.
 * @param {Object} [options={}] - The conversion options.
 * @param {string|boolean} [options.scoped] - The scoped class name or a boolean value indicating whether to use the default scoped class name.
 * @returns {string} The converted HTML string.
 */
function convertSchemaToHtml(schema, options = {}) {
  let { scoped } = options
  let html = ''
  if (typeof schema === 'string' || schema instanceof String) {
    schema = JSON.parse(schema)
  }

  if (typeof options === 'string' || options instanceof String || options === true) {
    scoped = options
  }

  if (schema.type === 'root' && schema.children.length > 0) {
    if (scoped) {
      html += `
      <div class="${scoped === true ? `rte` : scoped}">
        ${convertSchemaToHtml(schema.children, options)}
      </div>
      `
    } else {
      html += convertSchemaToHtml(schema.children, options)
    }
  } else {
    for (const el of schema) {
      switch (el.type) {
        case 'paragraph':
          html += buildParagraph(el, options)
          break
        case 'heading':
          html += buildHeading(el, options)
          break
        case 'list':
          html += buildList(el, options)
          break
        case 'list-item':
          html += buildListItem(el, options)
          break
        case 'link':
          html += buildLink(el, options)
          break
        case 'text':
          html += buildText(el, options)
          break
        default:
          break
      }
    }
  }
  return html
}

function getClass(tag, classes) {
  if (classes && classes[tag]) {
    return classes[tag]
  } else {
    return null
  }
}

function outputAttributes(attributes) {
  if (!attributes && attributes?.class) return ''
  const ATTRIBUTE_SEPARATOR = ' '
  return Object.keys(attributes)
    .map(key => {
      if (attributes[key]) {
        return `${ATTRIBUTE_SEPARATOR}${key}="${attributes[key]}"`
      }
    })
    .join('')
}

function createElement(tag, classes, content, attributes = {}) {
  attributes = { ...attributes, class: getClass(tag, classes) }
  return `<${tag}${outputAttributes(attributes)}>${content}</${tag}>`
}

function buildParagraph(el, options) {
  const { classes } = options
  return createElement('p', classes, convertSchemaToHtml(el?.children, options))
}

function buildHeading(el, options) {
  const { classes } = options
  const tag = `h${el?.level}`
  return createElement(tag, classes, convertSchemaToHtml(el?.children, options))
}

function buildList(el, options) {
  const { classes } = options
  const tag = el?.listType === 'ordered' ? 'ol' : 'ul'
  return createElement(tag, classes, convertSchemaToHtml(el?.children, options))
}

function buildListItem(el, options) {
  const { classes } = options
  return createElement('li', classes, convertSchemaToHtml(el?.children, options))
}

function buildLink(el, options) {
  const { classes } = options
  const attributes = {
    href: el?.url,
    title: el?.title,
    target: el?.target,
  }
  return createElement('a', classes, convertSchemaToHtml(el?.children, options), attributes)
}

function buildText(el, options) {
  const { classes, newLineToBreak } = options
  if (el?.bold && el?.italic) {
    return createElement('strong', classes, createElement('em', classes, el?.value))
  } else if (el?.bold) {
    return createElement('strong', classes, el?.value)
  } else if (el?.italic) {
    return createElement('em', classes, el?.value)
  } else {
    return newLineToBreak ? el?.value?.replace(/\n/g, '<br>') : el?.value
  }
}

// EXTERNAL MODULE: ./_components/customer/storefront-repository.js + 20 modules
var storefront_repository = __webpack_require__(4319);
;// ./_components/sections/byo/product-modal/index.js





class ByoProductModalController extends stimulus.Controller {
  static values = { canSubscribe: Boolean }

  async show(productId, hideCta) {
    const dialog = document.querySelector(
      `dialog[data-product-id="${productId}"]`
    )

    if (dialog) {
      dialog.showModal()
    } else {
      await this.render(productId, hideCta)

      document
        .querySelector(`dialog[data-product-id="${productId}"]`)
        .showModal()
    }
  }

  async render(productId, hideCta) {
    if (!document.querySelector(`dialog[data-product-id="${productId}"]`)) {
      const template = this.element.content.cloneNode(true)
      const productInfo = await storefront_repository["default"].getProduct(productId)

      if (!productInfo) {
        console.warn('Product could not be found')
        return
      }

      this.createDialogElement(template, productInfo, productId, hideCta)
      document.querySelector('#byo').appendChild(template)
    }
  }

  addContent(containerToAddContentTo, containerToRemove, content) {
    if (content) {
      containerToAddContentTo.textContent = content
    } else {
      containerToRemove.remove()
    }
  }

  createDialogElement(template, product, productId, hideCta) {
    const findEl = (el) => {
      return template.querySelector(`[data-identifier="${el}"]`)
    }

    if (product.productType === 'Coffee Sleeve') {
      if (product.roaster) {
        findEl('roasterName').textContent = product.roaster.reference.name.value
      } else {
        findEl('roasterName').remove()
      }
      findEl('container').classList.add('grid-background')
      findEl('container').classList.remove('md:flex-col', 'md:max-w-[392px]')
      findEl('imageContainer').classList.remove('md:mt-0')
    } else {
      findEl('roasterName').remove()
      findEl('container').classList.add('bg-white')
      findEl('container').classList.remove('md:flex-row', 'md:max-w-[80ch]')
      findEl('imageContainer').classList.remove('md:my-12', 'w-full')
    }

    const imageUrl =
      product.productCardImage?.reference?.image?.url ||
      product.featuredImage.url
    const variant = (
      product.variants.edges.find((v) => {
        v.node.selectedOptions[0].value === '8ct'
      }) || product.variants.edges[0]
    ).node
    const price = this.#price(product, variant)
    const longOrigin = product.origin?.value || product.shortOrigin?.value
    const pricePerCup = product.capsulesCount
      ? price / product.capsulesCount.value
      : null
    findEl('image').src = imageUrl
    findEl('title').textContent = product.title
    findEl('longDescription').textContent =
      product.longDescription?.value || product.oneLineExplanation?.value
    findEl('price').textContent = (0,format_money.formatMoney)(price).replace(/\.00/g, '')

    this.addContent(
      findEl('tag'),
      findEl('tagContainer'),
      product.productCardTag?.value
    )
    this.addContent(
      findEl('roastLevel'),
      findEl('roastLevelContainer'),
      product.roastLevel?.value
    )
    this.addContent(
      findEl('longOrigin'),
      findEl('longOriginContainer'),
      longOrigin
    )
    this.addContent(
      findEl('coffeeType'),
      findEl('coffeeTypeContainer'),
      product.coffeeType?.value
    )
    this.addContent(
      findEl('producer'),
      findEl('producerContainer'),
      product.producer?.value
    )
    this.addContent(
      findEl('sourcing'),
      findEl('sourcingContainer'),
      product.sourcing?.value
    )
    this.addContent(
      findEl('caffeineContent'),
      findEl('caffeineContentContainer'),
      product.caffeineContent?.value
    )
    this.addContent(
      findEl('varieties'),
      findEl('varietiesContainer'),
      product.varieties?.value
    )
    this.addContent(
      findEl('flavorNotes'),
      findEl('flavorNotesContainer'),
      product.flavorNotes?.value
    )

    if (pricePerCup) {
      findEl('capsulesCount').textContent = `${
        product.capsulesCount.value
      } capsules | ${(0,format_money.formatMoney)(pricePerCup).replace(/\.00/g, '')} per cup`
    } else {
      findEl('capsulesCount').remove()
    }

    if (product.processingMethods) {
      const methods = JSON.parse(product.processingMethods.value)

      findEl('processingMethods').textContent = methods.join(', ')
    } else {
      findEl('processingMethodsContainer').remove()
    }

    if (product.tasteProfile) {
      const profiles = JSON.parse(product.tasteProfile.value)

      profiles.forEach((profile) => {
        findEl(profile).classList.remove('hidden')
      })
    }

    if (product.roaster) {
      findEl(
        'roasterStoryName'
      ).textContent = `${product.roaster.reference.name.value}'s Story`
      const roasterImageUrl = product.roaster.reference.images?.references?.nodes?.[0]?.image?.reference?.image?.url
      if (roasterImageUrl) {
        findEl('roasterImage').src = roasterImageUrl
      }
      else {
        findEl('roasterImage').remove()
      }
      findEl('roasterSectionName').textContent =
        product.roaster.reference.name.value
      findEl('roasterIntroContent').innerHTML = convertSchemaToHtml(
        product.roaster.reference.introContent.value
      )
      if (product.roaster.reference.location) {
        findEl('roasterLocation').textContent =
          product.roaster.reference.location.value
      } else {
        findEl('roasterLocationContainer').remove()
      }
    } else {
      findEl('roasterContainer').remove()
    }

    findEl('subtractButton').dataset.productId = productId
    findEl('subtractButton').dataset.variantId = variant.id.replace(/^\D+/g, '')
    findEl('subtractButton').dataset.variantPrice = price


    const button = findEl('button')

    if (hideCta) {
      button.remove()
    } else {
      button.dataset.productId = productId
      button.dataset.variantId = variant.id.replace(/^\D+/g, '')
      button.dataset.productSku = variant.sku
      button.dataset.variantPrice = price
      button.dataset.requiresStock = product.productType === 'Coffee Sleeve'
    }

    // Add event listener to close the dialog when the dialog backdrop is clicked
    template.firstElementChild.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) {
        e.currentTarget.close()
      }
    })

    // Let the BYO controller know when the modal is closed
    // so it can respond accordingly
    template.firstElementChild.dataset.action = 'close->byo#productModalClosed'

    template.firstElementChild.dataset.productId = productId
  }

  #price(product, variant) {
    if (this.canSubscribeValue) {
      return (product.subscriptionDisplayPrice?.value ||
        variant.sellingPlanAllocations.edges[0]?.node?.priceAdjustments[0]
          ?.price?.amount ||
        variant.price.amount) * 100
    } else {
      return variant.price.amount * 100
    }
  }
}

Stimulus.register('byo-product-modal', ByoProductModalController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(9569)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);